<svg width="8" height="14" viewBox="0 0 8 14" fill="#000000" stroke="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M7.71211 6.99999L1.70111 0.98999L0.287109 2.40399L4.88711 7.00399L0.287109 11.597L1.70111 13.011L7.71211 6.99999Z" fill="currentColor" />
  <path d="M5.24066 6.65044L0.994216 2.40399L1.70114 1.69707L7.00497 7.00002L1.70111 12.3039L0.994486 11.5973L5.24039 7.35781L5.59449 7.00426L5.24066 6.65044Z" stroke="currentColor" />
</svg>
